import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.84804 1.76001C5.26225 1.76001 5.59804 2.0958 5.59804 2.51001V4.6528C9.42688 1.31124 15.245 1.46397 18.892 5.11097C22.6984 8.91738 22.6984 15.0888 18.892 18.8952C15.0856 22.7016 8.91415 22.7016 5.10774 18.8952C3.20468 16.9921 2.25293 14.4964 2.25293 12.0031C2.25293 11.5889 2.58872 11.2531 3.00293 11.2531C3.41714 11.2531 3.75293 11.5889 3.75293 12.0031C3.75293 14.1148 4.55794 16.2241 6.1684 17.8345C9.38902 21.0552 14.6107 21.0552 17.8313 17.8345C21.0519 14.6139 21.0519 9.39226 17.8313 6.17164C14.7168 3.05714 9.73097 2.95451 6.49315 5.86375L8.966 6.08939C9.3785 6.12703 9.68238 6.49194 9.64474 6.90444C9.6071 7.31694 9.2422 7.62082 8.8297 7.58318L4.77989 7.21366C4.39368 7.17842 4.09804 6.85457 4.09804 6.46676V2.51001C4.09804 2.0958 4.43382 1.76001 4.84804 1.76001ZM12 5.25001C12.4142 5.25001 12.75 5.5858 12.75 6.00001V11.25H16.5C16.9142 11.25 17.25 11.5858 17.25 12C17.25 12.4142 16.9142 12.75 16.5 12.75H12C11.5858 12.75 11.25 12.4142 11.25 12V6.00001C11.25 5.5858 11.5858 5.25001 12 5.25001Z"
        fill={colorValue}
      />
    </svg>
  );
};
